const activitypackageorder = {
  getlist: 'activitypackageorder/getlist',
  update: 'activitypackageorder/update',
  add: 'activitypackageorder/add-by-admin',
  confirmpay: 'activitypackageorder/confirm-pay',
}
export default activitypackageorder